var WeakMap = require('./_WeakMap');

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/lodash/_metaMap.js
// module id = 710
// module chunks = 168707334958949